import { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";

// Single socket instance to prevent multiple connections
let socket = null;

const initializeSocket = () => {
  if (!socket) {
    // Use http:// instead of ws:// for socket.io
    socket = io(`${process.env.NEXT_PUBLIC_API_DOMAIN}`, {
        transports: ['websocket', "polling"],
        autoConnect: true,
        reconnection: true,
    });

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("❌ Socket disconnected:", reason);
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Socket connection error:", error);
    });

    socket.on("reconnect", (attemptNumber) => {
      console.log("🔄 Socket reconnected after", attemptNumber, "attempts");
    });
  }
  return socket;
};

export default initializeSocket;